import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const StyledItem = styled.li`
  display: flex;
  width: 100%;
  margin-bottom: 8px;
  border-radius: 8px;
  border: 1px solid ${ColorPalette.HEX.BrightGray};
  background-color: ${({ theme }) => theme.rulesList.background};
`;
